// Aviso de maioridade das telas públicas (/links, /entrar, espera do
// /atendimento24h e NPS). Mesmo texto do rodapé da landing (09/10/2026):
// o símbolo "18+" e "Jogue com responsabilidade" são as duas cláusulas que a
// Portaria SPA/MF 1.231/2024 e o Anexo X do CONAR pedem. O símbolo já cobre a
// idade, por isso a frase não repete "menores de 18".
//
// O link vai para a página de jogo responsável no domínio público, nunca no
// do admin. Abre em outra aba para não perder um formulário pela metade.
//
// Fica num componente só para nenhuma tela pública nascer sem ele.

export const URL_JOGO_RESPONSAVEL = 'https://www.clubesbrazil.com/jogo-responsavel'

export default function AvisoMaioridade() {
  return (
    <p className="relative z-10 mt-2 flex items-center justify-center gap-1.5 text-center text-[11px] text-[var(--cb-text-faint)]">
      <b className="font-semibold">18+</b>
      <a
        href={URL_JOGO_RESPONSAVEL}
        target="_blank"
        rel="noopener noreferrer"
        className="underline-offset-2 hover:underline"
      >
        Jogue com responsabilidade.
      </a>
    </p>
  )
}
